<template>
  <div class="mimicando--bg pb-5">
    <UserNavbar />
    <div class="intro">
      <h1>Mimicando</h1>
      <p class="lead">Reuna a galera e divirta-se com mais de 3500 palavras!</p>
      <a href="https://play.google.com/store/apps/details?id=net.ddns.artspon.mimicando&hl=pt_BR" class="btn btn-warning btn-lg" role="button">Baixe o app</a>
      <p class="text-muted mt-3">É de graça 😀</p>
    </div>

    <div class="features container text-center">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <img src="@/assets/img/news.png" class="img-fluid" width="128">
          <p class="text-white mt-2">Pacote inicial variado e super divertido! Buscamos sempre trazer novas palavras para que a diversão nunca acabe :D</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <img src="@/assets/img/mega_pack_1.png" class="img-fluid" width="128">
          <p class="text-white mt-2">Encontre pacotes de filmes, músicas, heróis, profissões, séries e muito mais!</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <img src="@/assets/img/palette.png" class="img-fluid" width="128">
          <p class="text-white mt-2">Quando ficar muito difícil fazer a mímica, conte com o recurso de desenho!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserNavbar from '@/components/UserNavbar'

export default {
  name: 'Home',
  components: {
    UserNavbar
  }
}
</script>

<style scoped>
.intro {
  color: white;
  height: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

/* .features {
  height: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
} */
</style>
